export const OFFERS_FAILED = 'loading_offers_failed';
export const OFFERS_LOADED = 'set_loaded_offers';
export const LOAD_OFFERS = 'load_offers';
